<template>
  <div>
    <a-table :columns="columns" :dataSource="document.HISTORY" size="middle" bordered></a-table>
    <div style="margin-bottom: 15px;text-align:center">
      <a-button type="danger" @click="handlerBack">{{$t('Close')}}</a-button>
    </div>
  </div>
</template>
<script>
export default {
  props: [
    "document",
    "fieldColumns",
    "prew_history",
    "USER_LIST",
    "MY_COMPANY_LIST",
    "COMPANY_LIST",
  ],
  data() {
    const columns = [
      {
        title: this.$t("Date of change"),
        dataIndex: "date_change",
        width: 200,
      },
      {
        title: this.$t("User"),
        dataIndex: "creator",
        width: 200,
        customRender: (text) =>
          this.getUser(text),
      },
      {
        title: this.$t("Change type"),
        dataIndex: "type_change",
        width: 150,
        customRender: (text) => {
          let kk = this.fieldColumns.find((x) => x.dataIndex == text);
          if (kk) {
            return kk.title;
          }
          return text;
        },
      },
      {
        title: this.$t("Old value"),
        dataIndex: "old",
        ellipsis: true,
        width: "30%",
        customRender: (text, record) => {
          let kk = this.fieldColumns.find(
            (x) => x.dataIndex == record.type_change
          );
          if (kk?.customRender) {
            let param = {};
            param[kk.dataIndex] = text;
            return kk.customRender(text, param);
          }
          return text;
        },
      },
      {
        title: this.$t("New value"),
        dataIndex: "new",
        ellipsis: true,
        width: "30%",
        customRender: (text, record) => {
          let kk = this.fieldColumns.find(
            (x) => x.dataIndex == record.type_change
          );
          if (kk?.customRender) {
            let param = {};
            param[kk.dataIndex] = text;
            return kk.customRender(text, param);
          }
          return text;
        },
      },
    ];
    return {
      count: 10,
      document_record: 0,
      columns,
    };
  },
  methods: {
    handlerBack() {
      this.$emit("onBack");
    },
    getUser(id) {
      let user = this.document.userList.find((x) => x.ID == id);
      return user ? user.NAME + " " + user.LAST_NAME : '';
    },
  },
  mounted() {
    BX24.resizeWindow(
      parseInt($("body #root_block").css("width")),
      parseInt($("body #root_block").css("height"))
    );
  },
};
</script>
<style scoped>
</style>
